import { TagsOutlined, TagOutlined } from "@ant-design/icons";

const menuList = [
  {
    title: "首頁",
    key: "/home",
    icon: <TagOutlined />,
    chidren: null,
    isPublic: true,
  },
  {
    title: "訊息公告作業",
    key: "mBBS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "訊息公告顯示",
        key: "/bulletin/searchbulletinboard",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "訊息管理作業",
        key: "/bulletin/managebulletinboard",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "權限設定作業",
    key: "mSYS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "目錄管理作業",
        key: "/member/role",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "用戶管理作業",
        key: "/member/user",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "業務管理作業",
    key: "mSYS002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "分類管理作業",
        key: "/work/category",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "業務管理作業",
        key: "/work/business",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "統計分析作業",
    key: "mSYS003",
    icon: <TagsOutlined />,
    children: [
      {
        title: "長條圖",
        key: "/statistics/bar",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "曲線圖",
        key: "/statistics/line",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "圓餅圖",
        key: "/statistics/pie",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "服務諮詢作業",
    key: "mOSS000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "諮詢項目管理",
        key: "/onestopservice/consulting",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "提問紀錄查詢",
        key: "/onestopservice/questionlog",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "關鍵詞彙查詢",
        key: "/onestopservice/keywordList",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "電腦報修作業",
    key: "mCFS000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "我的報修案件",
        key: "/fixcomputer/applycase",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "審核報修案件",
        key: "/fixcomputer/reviewcase",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "查詢歷史案件",
        key: "/fixcomputer/historyreviewcase",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "處理報修案件",
        key: "/fixcomputer/processcase",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "應屆畢業生調查",
    key: "mGAM000",
    icon: <TagsOutlined />,
    children: [
      {
        // 應屆畢業生
        title: "檢核個人基本資料",
        key: "/graduatefresh/preparation",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人 | 系主任 | 班導
        title: "檢視應屆畢業班",
        key: "/graduatefresh/graduateclass",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人 | 系主任 | 班導
        title: "查詢應屆畢業生",
        key: "/graduatefresh/graduatemanage",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人
        title: "校資庫4之10結果",
        key: "/alumni/tablereportstandard",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        //  業管
        title: "各學制就業統計",
        key: "/graduatefresh/freshworkpercentage",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 系統管理者
        title: "校資庫校系清單",
        key: "/alumni/tvedbdepartment",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "畢業生流向調查",
    key: "mGAM003",
    icon: <TagsOutlined />,
    children: [
      {
        // 研發處承辦人|系主任
        title: "流向調查負責師長",
        key: "/alumnisurvey/previousclassteacher",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人
        title: "變更負責師長作業",
        key: "/alumnisurvey/surveycounselorlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人|班導|系主任
        title: "一三五調查進度",
        key: "/alumnisurvey/surveyschedule",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人|班導|系主任|電訪員
        title: "一三五調查作業",
        key: "/alumnisurvey/surveyalumnilist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人|系主任
        title: "一三五調查結果",
        key: "/alumnisurvey/graduatesurveylist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處承辦人
        title: "畢流格式數據匯出",
        key: "/alumnisurvey/surveyearreport",
        icon: <TagOutlined />,
        chidren: null,
      },
      // {
      //     title: '流向調查現況',
      //     key: '/alumni/graduatesituation',
      //     icon: <TagOutlined />,
      //     chidren: null
      // },
      {
        //校友本人
        title: "基本資料校正",
        key: "/alumnisurvey/alumniapplymodify",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        //校友本人
        title: "畢業一年調查",
        key: "/alumnisurvey/surveyfirstyear",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        //校友本人
        title: "畢業三年調查",
        key: "/alumnisurvey/surveythreeyear",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        //校友本人
        title: "畢業五年調查",
        key: "/alumnisurvey/surveyfiveyear",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "校友服務作業",
    key: "mGAM001",
    icon: <TagsOutlined />,
    children: [
      {
        // 業管
        title: "校友個人資料",
        key: "/alumni/alumniinformation",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 校友業管 | 職涯業管 | 院長 | 系辦
        title: "校友畢業資料",
        key: "/alumni/alumnigraduate",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 系主任
        title: "指定調查人員",
        key: "/alumni/assigntasks",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 系主任
        title: "校友現況查詢",
        key: "/alumnisurvey/chiefsearchlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 業管
        title: "校友雇主清單",
        key: "/alumni/alumniemployer",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 系辦
        title: "近一年未更新",
        key: "/alumni/oneyearnotupdate",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "各項申請作業",
    key: "mGAM002",
    icon: <TagsOutlined />,
    children: [
      {
        // 業管
        title: "校友個資異動審查",
        key: "/alumnisurvey/alumniapplymodifylist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 業管
        title: "學思卡申辦處理",
        key: "/alumni/cardmanage",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 校友 | 業管
        title: "申請學思卡",
        key: "/alumni/cardapply",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 校友 | 業管
        title: "申請個資更新",
        key: "/alumni/alumniapplyUpdate",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "數據統計分析",
    key: "mDSS001",
    icon: <TagsOutlined />,
    children: [
      {
        //  秘書室業管 | 院長 | 系主任 | 系辦
        title: "各系校友異動統計",
        key: "/decisionsupport/alumnimodifystatisticslist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        //  秘書室業管 | 院長 | 系主任 | 系辦
        title: "各系校友就業統計",
        key: "/alumnisurvey/employmentratelist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        //  研發處業管 | 系主任 | 導師
        title: "滿一年就業分析",
        key: "/alumnisurvey/oneyearsurveya",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 研發處業管 | 系主任
        title: "一零四求職統計",
        key: "/alumnisurvey/jobsearchstatistics",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 秘書室業管
        title: "每月異動統計",
        key: "/alumni/monthstatisticslist",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "洽公實名制作業",
    key: "mRNS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "空間登錄作業",
        key: "/realnamecheck/registerspacelist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "實聯登錄紀錄",
        key: "/realnamecheck/footprintLog",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "獎項領取預約作業",
    key: "mARS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "預約申請",
        key: "/awardsreservation/registerreservation",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "預約現場領取",
        key: "/awardsreservation/onsiteclaimerlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "預約郵寄掛號",
        key: "/awardsreservation/sendmailclaimerlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "尚未預約清單",
        key: "/awardsreservation/noneclaimerlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "現場配額統計",
        key: "/awardsreservation/dailyquotaanalysis",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "預約記錄查詢",
        key: "/awardsreservation/searchrecord",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "異動專案目的",
        key: "/awardsreservation/configproject",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "異動獲獎人員",
        key: "/awardsreservation/configqualify",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "異動預約日期",
        key: "/awardsreservation/configreservationdate",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "賃居管理作業",
    key: "mSLM001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "個人賃居填報",
        key: "/accommodation/surveystudent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "班級賃居統計",
        key: "/accommodation/classlivelist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "學生賃居狀況",
        key: "/accommodation/allstudentslivelist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "導師訪視對象",
        key: "/accommodation/needconfirmtutor",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "導師宣教對象",
        key: "/accommodation/needtalktutor",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "教官稽查對象",
        key: "/accommodation/needconfirminstructor",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "值班查詢作業",
        key: "/accommodation/onDutySearch",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "自學管理作業",
    key: "mECA001",
    icon: <TagsOutlined />,
    children: [
      {
        // 業管
        title: "系統組態管理",
        key: "/learnpoints/config",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 業管
        title: "自學項目清單",
        key: "/learnpoints/activity",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 業管
        title: "累積獲點排名",
        key: "/learnpoints/points",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 業管 / 授課教師
        title: "語文課程清單",
        key: "/learnpoints/course",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 學生
        title: "學期點數查詢",
        key: "/learnpoints/selfpoints",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "作品管理作業",
    key: "mCCW001",
    icon: <TagsOutlined />,
    children: [
      {
        // 業管 / 老師 / 學生
        title: "個人作品管理",
        key: "/culturalcreativeworks/works",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 業管 / 授課教師
        title: "課程作品管理",
        key: "/culturalcreativeworks/course",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 學生 / 職員 / 老師
        title: "個人課程作品",
        key: "/culturalcreativeworks/courseworks",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "作品分類統計",
    key: "mCCW002",
    icon: <TagsOutlined />,
    children: [
      {
        // 業管
        title: "作品分類管理",
        key: "/culturalcreativeworks/catalog",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        // 業管
        title: "物件類型統計",
        key: "/culturalcreativeworks/statistics",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "系統組態管理",
    key: "mESP000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "管理用戶清單",
        key: "/eportfolio/managebloggers",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "活力綜合指標",
    key: "mESP001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "學生活力指標",
        key: "/eportfolio/complexvtalitystudent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "教職活力指標",
        key: "/eportfolio/complexVitalityteacher",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "學生個別指標",
    key: "mESP002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "文創作品統計",
        key: "/eportfolio/vitalityobjects",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "優良事蹟統計",
        key: "/eportfolio/vitalitydeeds",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "專業證照統計",
        key: "/eportfolio/vitalitylicense",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "活動參加統計",
        key: "/eportfolio/vitalityactivity",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "教職個別指標",
    key: "mESP003",
    icon: <TagsOutlined />,
    children: [
      {
        title: "學術論文統計",
        key: "/eportfolio/vitalitydissertation",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "專業期刊統計",
        key: "/eportfolio/vitalityjournals",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "書籍出版統計",
        key: "/eportfolio/vitalitybook",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "專利註冊統計",
        key: "/eportfolio/vitalitypatent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "產學合作統計",
        key: "/eportfolio/vitalityproject",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "績優獲獎統計",
        key: "/eportfolio/vitalityawarded",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "展覽表演統計",
        key: "/eportfolio/vitalityxhibition",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "歷程檔案管理",
    key: "mESP004",
    icon: <TagsOutlined />,
    children: [
      {
        title: "前台顯示設定",
        key: "/eportfolio/config",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "基本資料管理",
        key: "/eportfolio/baseinfo",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "個人簡介設定",
    key: "mESP005",
    icon: <TagsOutlined />,
    children: [
      {
        title: "相關連結設定",
        key: "/eportfolio/introductionlink",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "社團參與歷程",
        key: "/eportfolio/clubstudent",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "校園動態查詢",
    key: "mESP006",
    icon: <TagsOutlined />,
    children: [
      {
        title: "學期開課清單",
        key: "/eportfolio/opencourse",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "舉辦活動清單",
        key: "/eportfolio/holdEvent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "已參加之活動",
        key: "/eportfolio/joinactivity",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "已學習之課程",
        key: "/eportfolio/learnedcourse",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "經歷紀實查詢",
    key: "mESP007",
    icon: <TagsOutlined />,
    children: [
      {
        title: "證書證照",
        key: "/eportfolio/degreelicense",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "成就著作",
        key: "/eportfolio/deedsteacher",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "優良事蹟",
        key: "/eportfolio/deedsstudent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "個人作品",
        key: "/eportfolio/achievementworks",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "UCAN診斷查詢",
    key: "mESP009",
    icon: <TagsOutlined />,
    children: [
      {
        title: "UCAN測驗平台",
        key: "/eportfolio/ucanssolink",
        icon: <TagOutlined />,
        chidren: null,
        isBlank: true,
      },
      {
        title: "人格類型探索",
        key: "/eportfolio/coursemapstudentucanholland",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "職業興趣探索",
        key: "/eportfolio/coursemapstudentucandgnexplore",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "共通職能診斷",
        key: "/eportfolio/coursemapstudentucancommoccupation",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "專業職能診斷",
        key: "/eportfolio/coursemapstudentucanalsresult",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "學習成效查詢",
    key: "mESP008",
    icon: <TagsOutlined />,
    children: [
      {
        title: "人才完成狀況",
        key: "/eportfolio/coursemapstudentcompletedtalent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "能力完成狀況",
        key: "/eportfolio/coursemapstudentcompletedability",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "指標完成狀況",
        key: "/eportfolio/coursemapstudentcompletedindex",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "培訓課程查詢",
        key: "/eportfolio/coursemapstudentcourseplan",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "選課導航查詢",
        key: "/eportfolio/coursemapstudentcoursesuggest",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "學習地圖查詢",
        key: "/eportfolio/coursemapstudentcourselearnmap",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "證照地圖查詢",
        key: "/eportfolio/coursemapstudentcourselicensemap",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "職涯發展查詢",
    key: "mESP010",
    icon: <TagsOutlined />,
    children: [
      {
        title: "就業資訊",
        key: "/eportfolio/coursemapstudentoccupation",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "國家考試",
        key: "/eportfolio/coursemapstudentcivilservice",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "升學進修",
        key: "/eportfolio/coursemapstudentmatriculation",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "空間借用管理",
    key: "mLRS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "空間參數管理",
        key: "/spacelend/spaceconfig",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "空間參數管理",
    key: "mLRS00",
    icon: <TagsOutlined />,
    children: [
      {
        title: "借用管理",
        key: "/spacelend/spacemanagement",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "時段管理",
        key: "/spacelend/timemanagement",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "座位管理",
        key: "/spacelend/sitemanagement",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "設備管理",
        key: "/spacelend/devicemanagement",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "空間借用申請",
    key: "mLRS002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "借用申請",
        key: "/spacelend/userborrowspace",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "借用紀錄",
        key: "/spacelend/userborrowlog",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "空間借用審核",
    key: "mLRS003",
    icon: <TagsOutlined />,
    children: [
      {
        title: "案件一審",
        key: "/spacelend/confirmorreviewa",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "案件二審",
        key: "/spacelend/confirmorreviewb",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "案件三審",
        key: "/spacelend/confirmorreviewc",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "案件查詢",
        key: "/spacelend/confirmorreviewhistory",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "空間借用統計",
    key: "mLRS004",
    icon: <TagsOutlined />,
    children: [
      {
        title: "借用情況",
        key: "/spacelend/spacestatussearch",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "違規紀錄",
        key: "/spacelend/correctlog",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "當期上傳統計",
    key: "mTMS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "教材上傳明細",
        key: "/teachingMaterial/materialstatuslist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "專兼任教材統計",
        key: "/teachingMaterial/finishbyfulltime",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "科系教材統計",
        key: "/teachingMaterial/finishbydepartment",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "歷史上傳統計",
    key: "mTMS002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "教材上傳明細",
        key: "/teachingMaterial/historymaterialstatuslist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "專兼任教材統計",
        key: "/teachingMaterial/historyfinishbyfulltime",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "科系教材統計",
        key: "/teachingMaterial/historyfinishbydepartment",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "競賽報名",
    key: "mCSLC001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "我要報名",
        key: "/contestsignup/myparticipantregisterlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "作品初審",
        key: "/contestsignup/juryallworkslist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "作品圈選",
        key: "/contestsignup/managerchoiceworkslist",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "作品票選",
    key: "mCSLL001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "我要投票",
        key: "/contestsignup/voterchoiceworkslist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "作品綜評",
        key: "/contestsignup/managersetfinishscorelist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "票選抽獎",
        key: "/contestsignup/managerlotterylist",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "校園空間管理",
    key: "mUSM001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "基本資料管理",
        key: "/spacemanagement/base",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "異動歷程查詢",
        key: "/spacemanagement/history",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "部門清單管理",
        key: "/spacemanagement/spacedepartment",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "所轄空間維護",
        key: "/spacemanagement/unit",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "基本資料查詢",
        key: "/spacemanagement/search",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "教室排課統計",
    key: "mUSM002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "本學期每周預劃",
        key: "/spacemanagement/onesemesterweektimes",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "近三期每周預劃",
        key: "/spacemanagement/threesemesterweektimes",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "空間資訊統計",
    key: "mUSM003",
    icon: <TagsOutlined />,
    children: [
      {
        title: "空間借用統計",
        key: "/spacemanagement/borrowtotaltimes",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "用途別統計",
        key: "/spacemanagement/usetypetotal",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "校資庫統計",
        key: "/spacemanagement/tvbtypetotal",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "品保管理作業",
    key: "mTQA000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "撰寫人員清單",
        key: "/teachingquailty/workerlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "空白報告格式",
        key: "/teachingquailty/A00",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "全校評量報告",
        key: "/teachingquailty/allmanualindex",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "校級品保作業",
    key: "mTQA001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "制度規範作業管理",
        key: "/teachingquailty/normmanage",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "校目標素養能力",
        key: "/teachingquailty/workalist",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "院級品保作業",
    key: "mTQA002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "院目標素養能力",
        key: "/teachingquailty/workblist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "院級評量報告",
        key: "/teachingquailty/workbreport",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "系所品保作業",
    key: "mTQA003",
    icon: <TagsOutlined />,
    children: [
      {
        title: "系所評量報告",
        key: "/teachingquailty/workcreport",
        icon: <TagOutlined />,
        chidren: null,
      },
      // {
      //     title: '碩班評量報告',
      //     key: '/teachingquailty/workdreport',
      //     icon: <TagOutlined />,
      //     chidren: null
      // },
    ],
  },
  {
    title: "院內互評作業",
    key: "mTQA005",
    icon: <TagsOutlined />,
    children: [
      {
        title: "系所主任簽核",
        key: "/teachingquailty/bosscd",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "院內評委分派",
        key: "/teachingquailty/secretaryassign",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "院級委員評核",
        key: "/teachingquailty/reviewdepartment",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "校級評核作業",
    key: "mTQA004",
    icon: <TagsOutlined />,
    children: [
      {
        title: "院中心級簽核",
        key: "/teachingquailty/bossa",
        icon: <TagOutlined />,
        chidren: null,
      },
      // {
      //     title: '中心主任簽核',
      //     key: '/teachingquailty/bossb',
      //     icon: <TagOutlined />,
      //     chidren: null
      // },
      {
        title: "校級委員評核",
        key: "/teachingquailty/reviewschool",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "參考來源查詢",
    key: "mTQA006",
    icon: <TagsOutlined />,
    children: [
      {
        title: "相關系統連結",
        key: "/teachingquailty/syslink",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "課程地圖數據",
        key: "/teachingquailty/workclist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "畢業生問卷結果",
        key: "/teachingquailty/graduatesurvey",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "教學務基本資料",
    key: "mTUT000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "學籍資訊查詢",
        key: "/school/schoolrollsearch",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "校門進出管制作業",
    key: "mGSM000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "校門登記控制",
        key: "/gatesecurity/gatecontrolconfig",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "校門組態紀錄",
        key: "/gatesecurity/gatecontrolloglist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "最近一筆登記",
        key: "/gatesecurity/lastenrolmentview",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "校門進出登記",
        key: "/gatesecurity/signerenrolmentself",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "今日進出紀錄",
        key: "/gatesecurity/signerenrolmentlist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "過往進出紀錄",
        key: "/gatesecurity/signerenrolmenthistorylist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "系所統計紀錄",
        key: "/gatesecurity/departmentanalyzelist",
        icon: <TagOutlined />,
        chidren: null,
      },

      {
        title: "進出登記補登",
        key: "/gatesecurity/signerenrolmentview",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "資訊素養測驗",
    key: "mILA000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "AI課課程清單",
        key: "/inforliteracy/ilacourselist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "AI課學生清單",
        key: "/inforliteracy/ilastudentlist",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "日間部生源規劃",
    key: "mSSP000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "系所人員管理",
        key: "/studentsource/manageworker",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "生源總召設定",
        key: "/studentsource/deanTarget",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "七技生源規劃",
        key: "/studentsource/sourcejuniorplan",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "四技生源規劃",
        key: "/studentsource/sourceplan",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "系所七技生源規劃",
        key: "/studentsource/departmentjuniorplan",
        icon: <TagOutlined />,
        chidren: null,
      },
      // {
      //     title: '系所四技生源規劃',
      //     key: '/studentsource/departmentseniorplan',
      //     icon: <TagOutlined />,
      //     chidren: null
      // },
      {
        title: "系所四技生源管理",
        key: "/studentsource/sourceseniorplan",
        icon: <TagOutlined />,
        chidren: null,
      },
      // {
      //     title: '有把握數回報',
      //     key: '/studentsource/departmenttargetholdon',
      //     icon: <TagOutlined />,
      //     chidren: null
      // },
      {
        title: "個人責任員額",
        key: "/studentsource/departmentprincipal",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "進修部生源規劃",
    key: "mSSP010",
    icon: <TagsOutlined />,
    children: [
      {
        title: "系所生源規劃",
        key: "/studentsource/sourceplannight",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "個人責任員額",
        key: "/studentsource/departmentprincipalnight",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "日間部生源統計",
    key: "mSSP001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "日間部規劃目標",
        key: "/studentsource/departmentplanningrate",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "核心學校統計",
        key: "/studentsource/schoolplanstatistics",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "生源區域統計",
        key: "/studentsource/departmentzone",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "學院生源統計",
        key: "/studentsource/collegeplanstatistics",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "學院規劃明細",
        key: "/studentsource/collegeplanview",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "系所生源統計",
        key: "/studentsource/departmentplanstatistics",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "系所規劃明細",
        key: "/studentsource/departmentplanview",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "每月異動紀錄",
        key: "/studentsource/schoolplanmonthhistory",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "主管出訪明細",
        key: "/studentsource/deanchairgooutlog",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "院長出席統計",
        key: "/studentsource/collegehandlestatistices",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "系主任出席統計",
        key: "/studentsource/chairhandlestatistics",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "專責三合一統計",
        key: "/studentsource/principalallInonelist",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "IR生源學校分析",
        key: "/studentsource/irsourceschoolanalysis",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "IR入學管道分析",
        key: "/studentsource/irsourceentranceanalysis",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "進修部生源統計",
    key: "mSSP011",
    icon: <TagsOutlined />,
    children: [
      {
        title: "進修部規劃目標",
        key: "/studentsource/departmentplanningratenight",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "全校現況統計",
    key: "mSSP002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "現員上游學校查詢",
        key: "/studentsource/studentsnowinfoall",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "電子報管理",
    key: "mSMS000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "自建內容管理",
        key: "/sendmailmessage/creatornewscontent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "單位內容查詢",
        key: "/sendmailmessage/departnewscontent",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "歷史寄發內容",
        key: "/sendmailmessage/weeknewscontent",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "申請作業",
    key: "mAFS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "助學金申請",
        key: "/alumnischolarships/applyscholarship",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "申請紀錄查詢",
        key: "/alumnischolarships/studentapplylog",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "審查作業",
    key: "mAFS002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "申請案件處理",
        key: "/alumnischolarships/applycasemanagement",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "過往案件查詢",
        key: "/alumnischolarships/applycaselog",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "設定開放時間",
        key: "/alumnischolarships/statustimesetup",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "休假查詢作業",
    key: "mHSS001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "全校教職員休假查詢",
        key: "/holidaystatussearch/allholidaysearch",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "部門主管休假查詢",
        key: "/holidaystatussearch/supervisorholidaysearch",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "部門人員休假查詢",
        key: "/holidaystatussearch/unitholidaysearch",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "個人休假狀況查詢",
        key: "/holidaystatussearch/selfholidaysearch",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "各類教學服務",
    key: "mAPC000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "課綱規劃服務",
        key: "/aiprompt/courseoutline",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "模擬出題測驗",
        key: "/aiprompt/examquestion",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "課後學生提問",
        key: "/aiprompt/aicoursereponse",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "各類學習服務",
    key: "mAPC001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "與你聊聊",
        key: "/aiprompt/counseling",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "修課建議",
        key: "/aiprompt/courseselection",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "公開課自學",
        key: "/aiprompt/ainotebooklmsearch",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "課後助教",
        key: "/aiprompt/aipromptstandard",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  // {
  //   title: "基礎程式設計課",
  //   key: "mAPC002",
  //   icon: <TagsOutlined />,
  //   children: [
  //     {
  //       title: "1.1.計算機基礎",
  //       key: "/aiprompt/class_C0001_12",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "1.2.程式設計基礎",
  //       key: "/aiprompt/class_C0001_13",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "1.3.控制結構",
  //       key: "/aiprompt/class_C0001_14",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "1.4.函數與物件導向",
  //       key: "/aiprompt/class_C0001_21",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "1.5.多種程式語言介紹",
  //       key: "/aiprompt/class_C0001_22",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "2.1.JavaScript介紹",
  //       key: "/aiprompt/class_C0001_23",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "2.2.網頁範例練習",
  //       key: "/aiprompt/class_C0001_24",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "3.1.Python介紹",
  //       key: "/aiprompt/class_C0001_31",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     {
  //       title: "3.2.Python範例練習",
  //       key: "/aiprompt/class_C0001_32",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //   ],
  // },
  // {
  //   title: "測試用AI應答",
  //   key: "mAPC003",
  //   icon: <TagsOutlined />,
  //   children: [
  //     {
  //       title: "測試用AI應答",
  //       key: "/aiprompt/class_C0001_11",
  //       icon: <TagOutlined />,
  //       chidren: null,
  //     },
  //     // {
  //     //     title: '1.2.計算機基礎',
  //     //     key: '/aiprompt/class_C0001_12',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '1.3.程式設計基礎',
  //     //     key: '/aiprompt/class_C0001_13',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '1.4.控制結構',
  //     //     key: '/aiprompt/class_C0001_14',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '1.5.函數與物件導向',
  //     //     key: '/aiprompt/class_C0001_21',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '1.6.多種程式語言介紹',
  //     //     key: '/aiprompt/class_C0001_22',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '2.3.JavaScript介紹',
  //     //     key: '/aiprompt/class_C0001_23',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '2.4.網頁範例練習',
  //     //     key: '/aiprompt/class_C0001_24',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '3.1.Python介紹',
  //     //     key: '/aiprompt/class_C0001_31',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //     // {
  //     //     title: '3.2.Python範例練習',
  //     //     key: '/aiprompt/class_C0001_32',
  //     //     icon: <TagOutlined />,
  //     //     chidren: null
  //     // },
  //   ],
  // },
  {
    title: "個人出缺勤管理",
    key: "mPIM000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "每月簽到退管理",
        key: "/punchinout/clocklogself",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "加班管理",
        key: "/punchinout/overtimelogself",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "調換管理",
        key: "/punchinout/swaplogself",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "彈班管理",
        key: "/punchinout/flexiblelogself",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "職工申請案件審核",
    key: "mPIM001",
    icon: <TagsOutlined />,
    children: [
      {
        title: "申請案件審核",
        key: "/punchinout/allapplycasesreview",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "職工出缺勤管制",
    key: "mPIM002",
    icon: <TagsOutlined />,
    children: [
      {
        title: "人員打卡紀錄查詢",
        key: "/punchinout/clocklogstaff",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "人員單月加班統計",
        key: "/punchinout/overtimemonthnowstaff",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "人員考勤告警紀錄",
        key: "/punchinout/staffbunchwarning",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "職工班表維護",
    key: "mPIM003",
    icon: <TagsOutlined />,
    children: [
      {
        title: "日期區間彈班",
        key: "/punchinout/flexibleloggroup",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "全體適用班表",
        key: "/punchinout/standardtimestaff",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "職工單日彈班",
        key: "/punchinout/flexiblelogstaff",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "職工加班明細",
        key: "/punchinout/overtimelogstaff",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "職工打卡補登",
        key: "/punchinout/backfilllogstaff",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "打卡紀錄註銷",
        key: "/punchinout/bunchLogStaff",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "職工休假管理",
    key: "mPIM04",
    icon: <TagsOutlined />,
    children: [
      {
        title: "個人請假紀錄",
        key: "/punchinout/staffleaveapplylog",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "個人請假統計",
        key: "/punchinout/staffleavestatistics",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "職工請假查詢",
        key: "/punchinout/staffleavelogsearch",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "AINotebooklm",
    key: "mNMS000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "所有公開筆記",
        key: "/ainotebooklm/allnotebooklm",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "我的最愛筆記",
        key: "/ainotebooklm/chosennotebooklm",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "我的個人筆記",
        key: "/ainotebooklm/mynotebooklm",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
  {
    title: "遠距教學管理",
    key: "mRTS000",
    icon: <TagsOutlined />,
    children: [
      {
        title: "遠距教學課程",
        key: "/distancelearning/allcourse",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "課程學習檢核",
        key: "/distancelearning/studenthourscheck",
        icon: <TagOutlined />,
        chidren: null,
      },
      {
        title: "學生學習統計",
        key: "/distancelearning/studentselfhours",
        icon: <TagOutlined />,
        chidren: null,
      },
    ],
  },
];

export default menuList;
